(function () {
	let swiperMulticolumn;
	let sectionResizeObserver;

	const initSlider = (multicolumnSwipeEnabled) => {
		if (!multicolumnSwipeEnabled || swiperMulticolumn) return;
		multicolumnSwipeEnabled.classList.add('multicolumn-swiper-wrapper');
		const slides = multicolumnSwipeEnabled.querySelectorAll('.multicolumn-list__item');
		const isTwoColumnsMobile = multicolumnSwipeEnabled.dataset.mobileTwoColumns === 'true';

		slides.forEach(slide => {
			slide.classList.add('swiper-slide');
		});

		swiperMulticolumn = new Swiper(multicolumnSwipeEnabled, {
			loop: false,
			slidesPerView: isTwoColumnsMobile ? 2 : 1,
			spaceBetween: 16,
			navigation: {
				nextEl: multicolumnSwipeEnabled.querySelector('.multicolumn-button-next'),
				prevEl: multicolumnSwipeEnabled.querySelector('.multicolumn-button-prev'),
			},

		});

	};

	const destroySlider = (multicolumnSwipeEnabled) => {
		if (!multicolumnSwipeEnabled) return;
		multicolumnSwipeEnabled.classList.remove('multicolumn-swiper-wrapper');
		const slides = multicolumnSwipeEnabled.querySelectorAll('.multicolumn-list__item');

		if (swiperMulticolumn) swiperMulticolumn.destroy(true, true);
		swiperMulticolumn = undefined;

		slides.forEach(slide => {
			slide.removeAttribute('style');
			slide.classList.remove('swiper-slide')
		});
	}

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector('.multicolumn-section');
		const multicolumnSwipeEnabled = multicolumnSection?.querySelector('.swiper--multicolumn');
		if (!multicolumnSection || !multicolumnSwipeEnabled) return;

		sectionResizeObserver = new ResizeObserver((entries) => {

			const [entry] = entries;

			if (entry.contentRect.width < 576 && multicolumnSwipeEnabled) {
				initSlider(multicolumnSwipeEnabled);
			} else if (swiperMulticolumn) {
				destroySlider(multicolumnSwipeEnabled);
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	}

	if (swiperMulticolumn) {
		const multicolumnSwipeEnabled = document.querySelector(".swiper--multicolumn");
		destroySlider(multicolumnSwipeEnabled);
	}
	initMulticolumn();
	document.addEventListener('shopify:section:load', function () {
		if (swiperMulticolumn) {
			const multicolumnSwipeEnabled = document.querySelector(".swiper--multicolumn");
			destroySlider(multicolumnSwipeEnabled);
		}
		if (sectionResizeObserver) sectionResizeObserver.disconnect();
		initMulticolumn();
	});

})();